import { action, observable } from "mobx";

class AIAgentStore {
  @observable isOpen = false;
  @observable messages = [];
  @observable context = {
    url: window.location.href,
    title: document.title
  };

  @action
  toggle = () => {
    this.isOpen = !this.isOpen;
  };

  @action
  setIsOpen = (value) => {
    this.isOpen = value;
  };

  @action
  addMessage = (msg) => {
    this.messages.push(msg);
  };


  @action
  setContext = (location) => {
    this.context = {
      url: window.location.href,
      title: document.title,
      pathname: location?.pathname
    };
  };
}

export const aiAgentStore = new AIAgentStore();
export default aiAgentStore;
